export default __webpack_public_path__ + "static/media/NEPHROSIS.77f3fc6c.jpg";